import { useRef } from 'react';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';

import { useClipboardCopy } from '../../components/useClipboardCopy.ts';

export interface CopyableValueProps {
  label: string;
  value: string;
  ariaLabel: string;
  copyLabel: string;
}

export function CopyableValue({
  label,
  value,
  ariaLabel,
  copyLabel,
}: Readonly<CopyableValueProps>): React.JSX.Element {
  const { copied, copy } = useClipboardCopy();
  const inputRef = useRef<HTMLInputElement | null>(null);

  const handleCopy = async () => {
    const ok = await copy(value);
    if (!ok) inputRef.current?.select();
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
      <TextField
        label={label}
        value={value}
        fullWidth
        inputRef={inputRef}
        onFocus={(event) => event.target.select()}
        slotProps={{
          input: { readOnly: true },
          htmlInput: { 'aria-label': ariaLabel, style: { fontFamily: 'monospace' } },
        }}
      />
      <Box>
        <Button variant="outlined" onClick={() => void handleCopy()}>
          {copied ? 'Copied' : copyLabel}
        </Button>
        {copied && (
          <Typography component="span" variant="body2" sx={{ ml: 1.5, opacity: 0.8 }}>
            Copied to clipboard.
          </Typography>
        )}
      </Box>
    </Box>
  );
}

export default CopyableValue;
